module.exports = __webpack_public_path__ + "static/media/protected.e799caa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Protection/protected.svg
// module id = 1476
// module chunks = 103